import {AiChatOpenEditorType, GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {trackFakeDoorPostUsedIfNeeded} from '@Libraries/marketing-planner.library';
import {openEditorInNewTab} from '@Components/ai-chat-window/lib/open-editor-tab.library';

interface UseOpenChatImageInEditor {
  openPosterInEditor: (hashedId: string) => void;
  openUserDesignInEditor: (posterHashedId: string) => void;
}

const openEditorTab = (path: string, openEditorType: AiChatOpenEditorType): void => {
  trackFakeDoorPostUsedIfNeeded();
  openEditorInNewTab(window.PMW.util.site_url(path));
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR, {[GA4EventParamName.TYPE]: openEditorType});
};

export const useOpenChatImageInEditor = (): UseOpenChatImageInEditor => {
  const openPosterInEditor = (hashedId: string): void => {
    openEditorTab(`posterbuilder/loadFromAiChatImage/${hashedId}`, AiChatOpenEditorType.EDIT_AS_IMAGE);
  };

  const openUserDesignInEditor = (posterHashedId: string): void => {
    openEditorTab(`posterbuilder/load/${posterHashedId}`, AiChatOpenEditorType.EDITABLE_LAYERS);
  };

  return {openPosterInEditor, openUserDesignInEditor};
};
